import { Timestamp } from 'firebase/firestore';
import { triggerExposureCalc } from '../../hooks/useExposure';
import { createFutureOrder } from '../../sp-firebase/futureOrderFB';
import { addNotification, generateFutureOrder } from '../AdminChanges/AdminUtils';

export async function submitQuote(
  accountId: string,
  finishFunction: () => void,
  setIsLoading: (_value: boolean) => void,
) {
  const order = generateFutureOrder({
    formulaId: 'HRCc1',
    orderId: '0011',
    fromDate: new Date(2024, 10, 1).toLocaleDateString(),
    monthSpread: 10,
    quantity: 450_000,
  });
  setIsLoading(true);
  await createFutureOrder(accountId, order);
  if (accountId) {
    await addNotification(accountId, {
      id: 'hrc_out of balance_' + Timestamp.now().seconds,
      date: Timestamp.now(),
      type: 'alert',
      text: 'HR Steel out of balance',
      descriptionText: 'HR Steel needs to be balanced due to going out of balance',
      actionText: 'Balance now',
      actionUrl: 'balance',
      formulaId: ['HRCc1'],
      status: 'completed',
    });
    finishFunction();
    await triggerExposureCalc({
      accountId: accountId!,
      materialIds: ['HRCc1'],
    });
  }
  setIsLoading(false);
}
